const moveToMapPosition = (master, clones) => {
  const center = master.getCenter();
  const zoom = master.getZoom();
  const bearing = master.getBearing();
  const pitch = master.getPitch();

  clones.forEach((clone) => {
    clone.jumpTo({
      center,
      zoom,
      bearing,
      pitch
    });
  });
};

const syncMaps = (...args) => {
  let maps = args.length === 1 ? args[0] : args;

  // Define `on` and `off` first, because `sync` will call them.
  const on = () => {
    maps.forEach((map, index) => {
      map.on('move', fns[index]);
    });
  };

  const off = () => {
    maps.forEach((map, index) => {
      map.off('move', fns[index]);
    });
  };

  // Define `sync` before you create `fns`, since `fns` depends on `sync`.
  const sync = (master, clones) => {
    off();
    moveToMapPosition(master, clones);
    on();
  };

  // Now it's safe to reference `sync` while defining `fns`.
  const fns = maps.map((map, index) =>
    sync.bind(null, map, maps.filter((_, i) => i !== index))
  );

  on();

  // Return a cleanup function
  return () => {
    off();
  };
};

export default syncMaps;
